module.exports = __webpack_public_path__ + "media/images/eyecatch-correction-edac6c418dd88d20988aa6f6da487d80.svg";